import { useNavigate } from 'react-router-dom';
import { AnalysesPage } from '@practium/features/analyses';
import type { AnalysesPermissions, AnalysesTab } from '@practium/features/analyses';
import { useForBinding } from '@practium/features/forBinding';
import { usePermissions } from '@practium/features/permissions';

export const AnalysesPageClient = () => {
	const navigate = useNavigate();
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();

	const subject = isForBinding ? 'farmers-samples' : 'samples';
	const permissions: AnalysesPermissions = {
		canCreate: abilities.can('create', subject),
		canEdit: abilities.can('update', subject),
		canDelete: abilities.can('delete', subject),
	};

	const handleAddNew = (tab: AnalysesTab) => {
		navigate(`/analises/novo?type=${tab}`);
	};

	const handleViewItem = (tab: AnalysesTab, id: string) => {
		navigate(`/analises/ver?type=${tab}&id=${id}`);
	};

	return (
		<AnalysesPage
			permissions={permissions}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
		/>
	);
};
